import axios from "axios";
import { createKiddoAxios, getKiddoBaseUrl } from "./httpClient";

let API;

const initAPI = async () => {
  if (!API) {
    API = await createKiddoAxios();
  }
  return API;
};

export const loginTokenWeb = async (email, password) => {
  const api = await initAPI();

  const formData = new FormData();
  formData.append("email", email);
  formData.append("password", password);

  const response = await api.post("/Insert/LoginTokenWeb", formData);
  return response.data;
};

// REGISTER
export const registerApi = async ({
  firstName,
  lastName,
  email,
  password,
  confirmPassword,
  userType = "student",
  countryId,
}) => {
  const baseURL = await getKiddoBaseUrl();
  const payload = {
    firstName,
    lastName,
    email,
    password,
    confirmPassword,
    userType,
  };
  if (countryId) {
    payload.countryId = countryId;
  }

  const response = await axios.post(`${baseURL}/insert/register`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const changePassword = async ({
  userId,
  newPassword,
  confirmPassword,
}) => {
  const api = await initAPI();

  const response = await api.post(
    "/Insert/ChangePassword",
    {
      userId,
      newPassword,
      confirmPassword,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};


export const loginWithGoogleIdTokenApi = async (idToken) => {
  if (!idToken) throw new Error('Google idToken is required');
  const api = await initAPI();
  const response = await api.post("/Insert/GoogleLogin", { idToken });
  return response.data;
};
